import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle, Button } from "reactstrap";
import { getEvents, addEvent, deleteEvent, uploadImage } from "./UpdatesApi";
import EditModal from "../../Components/Shared/EditModal";

const ACCENT = "#BA7517";

// const API_BASE = process.env.REACT_APP_API_URL?.replace("/api", "") || "http://www.sswhite.systems:7168";

// const getImageSrc = (url) => {
//     if (!url) return null;
//     // Extract just the /uploads/... part
//     const match = url.match(/\/uploads\/.+/);
//     if (!match) return url;
//     // Prepend the API base URL
//     return `${API_BASE}${match[0]}`;
// };

// Round HOST-1: ?? (not ||) — in production the env var is DEFINED AS
// EMPTY on purpose, meaning "same origin" (host-relative /uploads/...).
// Only a build with the var entirely ABSENT (local dev) falls back to the
// localhost API host, exactly as before.
const SERVER_BASE = process.env.REACT_APP_SERVER_BASE ?? "https://localhost:7168";

const getImageSrc = (url) => {
    if (!url) return null;
    const match = url.match(/\/uploads\/.+/);
    if (!match) return url;
    return `${SERVER_BASE}${match[0]}`;
};

const EventCard = ({ data = [], role, refresh }) => {
    const canEdit = ["Manager", "HR Admin"].includes(role);

    const [items, setItems] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [content, setContent] = useState("");
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState("");
    const [eventDate, setEventDate] = useState("");
    const [hoveredId, setHoveredId] = useState(null);

    const load = async () => {
        const r = await getEvents();
        setItems(r);
    };

    useEffect(() => { load(); }, []);

    const onSave = async () => {
        let uploadedUrl = null;
        if (imageFile) uploadedUrl = await uploadImage(imageFile);

        const payload = {
            id: 0,
            type: "Event",
            title: "Upcoming Event",
            description: content,
            date: eventDate ? new Date(eventDate).toISOString() : new Date().toISOString(),
            imageUrl: uploadedUrl,
            employeeName: "",
            employeeRole: "",
            employeeImageUrl: "",
            eventLocation: "",
            eventTime: "",
        };

        await addEvent(payload);
        setContent(""); setEventDate(""); setImageFile(null); setImagePreview(""); setModalOpen(false);
        load();
    };

    const remove = async (id) => {
        await deleteEvent(id);
        load();
    };

    return (
        <Card style={styles.card}>
            <CardBody style={styles.cardBody}>
                <div style={{ ...styles.accentBar, background: ACCENT }} />

                <div className="dashboard-scroll-area">
                    {/* Header */}
                    <div style={styles.header}>
                        <CardTitle tag="h6" style={styles.title}>
                            <div style={{ ...styles.iconWrap, background: "#FAEEDA" }}>
                                <i className="bx bxs-calendar-event" style={{ color: ACCENT, fontSize: "15px" }} />
                            </div>
                            Upcoming Events
                        </CardTitle>
                        {canEdit && (
                            <Button size="sm" onClick={() => setModalOpen(true)} style={{ ...styles.addBtn, background: ACCENT }}>
                                + Add
                            </Button>
                        )}
                    </div>

                    {/* List */}
                    <ul className="list-unstyled mb-0">
                        {items.length ? items.map((i) => (
                            <li
                                key={i.id}
                                onMouseEnter={() => setHoveredId(i.id)}
                                onMouseLeave={() => setHoveredId(null)}
                                style={{
                                    ...styles.item,
                                    background: hoveredId === i.id ? "#FEF6E8" : "transparent",
                                }}
                            >
                                <div style={styles.itemLeft}>
                                    {i.imageUrl && (
                                        <img
                                            src={getImageSrc(i.imageUrl)}  // ✅ fixed
                                            alt="event"
                                            style={styles.eventImg}
                                        />
                                    )}
                                    <div>
                                        <span style={styles.itemTitle}>{i.description}</span>
                                        <small style={styles.itemDate}>{i.date?.split("T")[0]}</small>
                                    </div>
                                </div>
                                {canEdit && (
                                    <Button
                                        color="danger" outline size="sm"
                                        style={styles.deleteBtn}
                                        onClick={() => remove(i.id)}
                                    >
                                        Delete
                                    </Button>
                                )}
                            </li>
                        )) : <p style={styles.empty}>No upcoming events yet.</p>}
                    </ul>

                    {/* Footer */}
                    {items.length > 0 && (
                        <div style={styles.footer}>
                            <span style={{ ...styles.viewAll, color: ACCENT }}>View all →</span>
                        </div>
                    )}

                    <EditModal
                        isOpen={modalOpen}
                        toggle={(action) => { if (action === "save") onSave(); else setModalOpen(false); }}
                        title="Add Event"
                        content={content}
                        setContent={setContent}
                        imageFile={imageFile}
                        setImageFile={(file) => { setImageFile(file); setImagePreview(URL.createObjectURL(file)); }}
                        imagePreview={imagePreview}
                        eventDate={eventDate}
                        setEventDate={setEventDate}
                    />
                </div>
            </CardBody>
        </Card>
    );
};

const styles = {
    card: { borderRadius: "16px", border: "0.5px solid #e8e8e8", boxShadow: "0 1px 6px rgba(0,0,0,0.06)", overflow: "hidden", marginBottom: "20px", position: "relative" },
    cardBody: { padding: "20px 20px 14px" },
    accentBar: { position: "absolute", top: 0, left: 0, width: "4px", height: "100%", borderRadius: "16px 0 0 16px" },
    header: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px" },
    title: { margin: 0, fontWeight: 600, fontSize: "14px", color: "#2C2C2A", display: "flex", alignItems: "center", gap: "8px" },
    iconWrap: { width: "30px", height: "30px", borderRadius: "8px", display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
    addBtn: { border: "none", borderRadius: "8px", fontSize: "12px", padding: "4px 12px", color: "#fff" },
    item: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", borderRadius: "8px", cursor: "default", marginBottom: "4px", transition: "background 0.15s", borderBottom: "0.5px solid #f0f0f0" },
    itemLeft: { display: "flex", alignItems: "center", gap: "10px" },
    eventImg: { width: "32px", height: "32px", borderRadius: "8px", objectFit: "cover", flexShrink: 0 },
    itemTitle: { fontSize: "13px", fontWeight: 600, color: "#2C2C2A", display: "block" },
    itemDate: { fontSize: "11px", color: "#888780", display: "block" },
    deleteBtn: { fontSize: "11px", padding: "2px 8px", flexShrink: 0 },
    empty: { fontSize: "13px", color: "#888780", margin: 0 },
    footer: { borderTop: "0.5px solid #f0f0f0", marginTop: "10px", paddingTop: "8px", textAlign: "right" },
    viewAll: { fontSize: "12px", cursor: "pointer", fontWeight: 500 },

};

export default EventCard;